import React from "react";
import { PencilIcon } from "@aureskonnect/react-ui";
import { Tooltip } from "@material-ui/core";
import classnames from "classnames";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { fetchSupport } from "./helper";
import { useSnapshot } from "valtio";
import { store } from "@components/VerticalLayout/store";
import { handleAddSalesMethodClick } from "./settingsService";
import { useFetchGlobal } from "../../../../api/hooks";

export default function EditButton({
    e,
    isEdited,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setRowData,
    setShopId,
    setSale,
    setSelectName,
    setSelectSales,
    setInputSaleMode,
    setLocalFilterActive,
    isModeOfSaleArchived,
    isLoading,
    oneShop,
    t,
    setFormState,
    isConsult,
    setSalesSupport,
    setTagsData,
    setModalState,
    modalState,
    setSalesModesTypesAndTag,
}: any) {
    const { fetchGlobal } = useFetchGlobal();

    const { userID, franchiseID, shopID } = useSnapshot(store);
    const shopId = oneShop ? shopID : 0;
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const handleEditClick = async ({
        isEdited,
        setIsActionsClicked,
        setActions,
        setIsEdited,
        setRowData,
        setShopId,
        setSale,
        setSelectName,
        setSelectSales,
        setInputSaleMode,
        setLocalFilterActive,
        selectedRow,
        setFormState,
    }: any) => {
        if (isEdited === true) {
            setIsActionsClicked((prev: any) => !prev);
            setActions(async () => {
                clearData();
                clearMultiCustomSelectionData();
                setFormState((prev: any) => ({
                    ...prev,
                    title: t(
                        isConsult
                            ? "View a sales method"
                            : "Modify a sales method"
                    ),
                    saleMode: selectedRow["Mode of sale"] || "",
                    tagsData: selectedRow.tag || [],
                    displayName:
                        selectedRow.advancedDisplayName?.languages?.[
                            i18nextLng
                        ] || "",

                    advancedDisplayName:
                        selectedRow.advancedDisplayName ||
                        prev.advancedDisplayName,
                    isNameExist: false,
                    tag: "", // <-- tu peux l'ajuster selon la logique métier
                    selectName: false,
                    inputSaleMode: false,
                    selectSales: false,
                }));
                setSalesSupport(selectedRow.support_vente);

                setTagsData(selectedRow.tag);
                setIsEdited(false);
                if (!modalState.isAddModeOfSaleClicked) {
                    setModalState((prev: any) => ({
                        ...prev,
                        isAddModeOfSaleClicked: true,
                    }));
                }
                setRowData(selectedRow);
                setShopId(selectedRow.shopId);
                await handleAddSalesMethodClick(
                    franchiseID,
                    shopId,
                    setSalesModesTypesAndTag,
                    setModalState,
                    setLocalFilterActive,
                    fetchGlobal
                );
                setSale(selectedRow);
                setSelectName(false);
                setSelectSales(false);
                setInputSaleMode(false);
                setLocalFilterActive(false);
            });
        } else {
            clearData();
            clearMultiCustomSelectionData();
            await handleAddSalesMethodClick(
                franchiseID,
                shopId,
                setSalesModesTypesAndTag,
                setModalState,
                setLocalFilterActive,
                fetchGlobal
            );
            fetchSupport(userID, franchiseID, i18nextLng, t, fetchGlobal);
            setFormState((prev: any) => ({
                ...prev,
                title: t(
                    isConsult ? "View a sales method" : "Modify a sales method"
                ),
                saleMode: selectedRow["Mode of sale"] || "",
                tagsData: selectedRow.tag || [],
                displayName:
                    selectedRow.advancedDisplayName?.languages?.[i18nextLng] ||
                    "",
                advancedDisplayName:
                    selectedRow.advancedDisplayName || prev.advancedDisplayName,
                isNameExist: false,
                tag: "",
                selectName: false,
                inputSaleMode: false,
                selectSales: false,
            }));
            setSalesSupport(selectedRow.support_vente);

            setTagsData(selectedRow.tag);
            if (!modalState.isAddModeOfSaleClicked) {
                setModalState((prev: any) => ({
                    ...prev,
                    isAddModeOfSaleClicked: true,
                }));
            }
            setRowData(selectedRow);
            setShopId(selectedRow.shopId);
            setSale(selectedRow);
            setSelectName(false);
            setSelectSales(false);
            setInputSaleMode(false);
            setLocalFilterActive(false);
        }
    };

    return (
        <Tooltip title={isModeOfSaleArchived ? "" : t("Edit")}>
            <div>
                <PencilIcon
                    onClick={async () =>
                        await handleEditClick({
                            isEdited,
                            setIsActionsClicked,
                            setActions,
                            setIsEdited,
                            setRowData,
                            setShopId,
                            setSale,
                            setSelectName,
                            setSelectSales,
                            setInputSaleMode,
                            setLocalFilterActive,
                            selectedRow: e.selectedRow,
                            setFormState,
                        })
                    }
                    height={25}
                    width={25}
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "pointer__clz cmn_icn_FRedit",
                        {
                            "not-allowed-icon__clz":
                                isModeOfSaleArchived || isLoading,
                        },
                        oneShop ? "mr-2" : "ml-3"
                    )}
                />
            </div>
        </Tooltip>
    );
}
